import { User, UserRoles } from 'types/user'
import { masterApiService, masterAxios, ssoAxios } from 'api/config'
import { store } from 'store/index'
import { settingsActions } from 'store/settings'
import { RegisterForm } from 'components/modals/RegisterModal'

type LoginResponse = {
  user: User
  token: string
  refreshToken: string | null
}

export const loginUser = async (email: string, password: string) => {
  try {
    const { data } = await ssoAxios.post<LoginResponse>('auth', undefined, {
      headers: {
        Authorization: `Basic ${btoa(`${email}:${password}`)}`,
      },
    })

    const user = data.user

    if ([UserRoles.ADMIN, UserRoles.OPERATOR, UserRoles.SUPERVISOR].includes(user.role)) {
      return Promise.reject('userNotAllowedToLogin')
    }

    store.dispatch(settingsActions.login(data))
    return data.user
  } catch (e) {
    return Promise.reject(e)
  }
}

export const registerUser = async (form: RegisterForm) => {
  try {
    await masterApiService.createItem('auth/register', {
      ...form,
      role: UserRoles.USER,
    })
    return await loginUser(form.email, form.password)
  } catch (e) {
    return Promise.reject(e)
  }
}

export const resetPassword = async (email: string) => {
  try {
    await masterAxios.post('password-resets', { email })
  } catch (e) {
    return Promise.reject(e)
  }
}
